import React, { useEffect, useRef } from "react";
import { motion, useAnimation, useInView } from "framer-motion";

export default function Handshake({ dimension = "150" }) {
  const controls = useAnimation();
  const iconRef = useRef(null);
  const isInView = useInView(iconRef, { once: true });
  useEffect(() => {
    if (isInView) {
      controls.start("visible");
    }
  }, [isInView]);

  const iconPath = {
    hidden: {
      pathLength: 0,
      stroke: "var(--secondary)",
    },
    visible: {
      pathLength: 1,
      stroke: [
        "var(--secondary)",
        "var(--secondary)",
        "var(--secondary)",
        "var(--secondary)",
        "var(--primary)",
      ],
      transition: {
        duration: 2,
        ease: "easeInOut",
      },
      transitionEnd: {
        fill: "var(--primary)",
      },
    },
  };
  return (
    <motion.svg
      width={dimension}
      height={dimension}
      viewBox="0 0 500 500"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={iconRef}
      initial="hidden"
      animate={controls}
    >
      <motion.path
        variants={iconPath}
        strokeWidth="5"
        d="M434.92 210.458C459.501 196.878 476.195 170.69 476.195 140.675C476.195 96.7456 440.454 61 396.52 61C352.586 61 316.85 96.7408 316.85 140.675C316.85 172.336 335.411 199.739 362.224 212.574C333.15 224.915 312.707 253.754 312.707 287.277L312.717 314.733L187.283 314.747L187.293 287.286C187.293 253.758 166.85 224.92 137.771 212.579C164.584 199.739 183.15 172.336 183.15 140.68C183.15 96.7504 147.41 61.0048 103.475 61.0048C59.5408 61.0048 23.8048 96.7456 23.8048 140.675C23.8048 170.69 40.4944 196.878 65.0752 210.458C33.0832 221.33 10 251.656 10 287.277V438.41H187.23L187.25 393.683C187.25 393.669 312.75 393.702 312.75 393.702L312.765 438.41H490V287.286C490 251.661 466.917 221.33 434.92 210.458ZM334.245 140.675C334.245 106.274 362.128 78.3904 396.525 78.3904C430.922 78.3904 458.8 106.274 458.8 140.675C458.8 175.072 430.917 202.955 396.52 202.955C362.123 202.955 334.245 175.072 334.245 140.675ZM41.2 140.675C41.2 106.274 69.088 78.3904 103.48 78.3904C137.877 78.3904 165.76 106.274 165.76 140.675C165.76 175.072 137.877 202.955 103.48 202.955C69.0832 202.955 41.2 175.072 41.2 140.675ZM169.85 421.019H27.3952V287.277C27.3952 252.093 63.4624 220.96 98.6512 220.96C133.84 220.96 169.907 252.093 169.907 287.277L169.898 314.776H162.63L124.686 260.862C111.717 243.414 88.0912 238.182 69.7168 251.306C51.8992 263.848 47.6176 288.458 60.16 306.28L109.893 376.941C117.285 387.438 129.318 393.683 142.158 393.683H169.869L169.85 421.019ZM227.392 376.278L142.149 376.288C134.978 376.288 128.234 372.789 124.11 366.923L74.3776 296.262C70.984 291.443 65.2192 276.299 79.72 265.523C94.3024 255.822 106.331 265.005 110.459 270.866L153.602 332.166L227.392 332.138C239.56 332.138 249.462 342.04 249.462 354.213C249.462 366.386 239.56 376.278 227.392 376.278ZM312.813 376.648H259.826C264.251 370.274 266.853 362.541 266.853 354.208C266.853 345.894 264.261 338.171 259.85 331.802H312.813V376.648ZM432.136 381.002C432.136 387.338 424.71 406.182 418.01 421.024H384.626C389.733 407.992 395.987 390.184 395.987 381.002V279.362C395.987 269.397 404.094 261.285 414.064 261.285C424.034 261.285 432.141 269.392 432.141 279.362L432.136 381.002ZM472.61 421.019H437.037C442.686 407.939 449.531 390.184 449.531 380.997V279.362C449.531 259.806 433.624 243.894 414.064 243.894C394.504 243.894 378.597 259.802 378.597 279.362V381.002C378.597 387.443 371.934 406.192 365.877 421.024H330.16L330.102 287.282C330.102 252.098 366.17 220.965 401.354 220.965C436.547 220.965 472.614 252.098 472.614 287.282L472.61 421.019Z"
      />
    </motion.svg>
  );
}
